module.exports = __webpack_public_path__ + "assets/img/benefit-6.b8529f9b.svg";